<template>
  <div class="chat-window">
    <slot></slot>
    <div class="messages-container">
      <!-- <div class="message" v-for="message in messages" :key="message.index"> -->
      <div class="menu-user"
        style="position:absolute;"
        v-show="ContextMenu"
        :style="{top:ContextMenuTop,left:ContextMenuLeft}"
       ><!--  v-on:mouseleave="hideContextMenu" -->
         <menu-user :userinfo='senduser'></menu-user>
      </div>
      
      <div class="messages-list">
            <template v-for="(message, index) in messages" :key="index">
                <div  class="message" v-if="message.from !==`Admin`" >     
                     
                    <chat-message
                    :userinfo="message"
                    :displaymytalk="false"
                    :displayProfileImage="false"
                    :lineheight="true"                   
                    :msg="message.text"
                    :isSame ="index>0 && messages[index-1].from === message.from"
                    :isMine="user.nic === message.from"
                    :owner="isOwner"
                    :manager="isManager"  
                    @view-user-info ="viewUserInfo"
                    />   
                             
                </div>
                <div class="adminMessage" v-else :class='`${message.color}`'>
                    {{message.text}}
                </div>
            </template>
      </div>
    </div>

    <div class="input-container" v-if=messageinput>     
         <!-- 
          2021-06-15 방 입장 유저도 채팅 가능 하게 
          방장 매니져만 채팅 되는 코드
          :readonly="!isAuth || ( !isManager && !isOwner && chat_roomId !== 'm1'  && !chat_roomId.includes('mtm'))" -->
        <div class="wrap-input">
          <div class="input-area">
            <input
              type="text"
              v-model="msg"
              class="chatmsg"
              :placeholder="switchMode"
              :readonly="!isAuth"
              @keyup.enter="sendMessage()"
              @click="authCheck('isMobile')"
            />
          </div>
            <!-- :readonly="!isChat || !isAuth || ( !isManager && !isOwner && chat_roomId !== 'm1'  && !chat_roomId.includes('mtm'))" -->
          <div class="button-area" >
            <button @click="sendMessage"
            :disabled="!msg">Send</button>
          </div>
        </div>
      
    </div>
  </div>
  <pop-slide-up :show="userInfo.show">
    <user-info  :data="userInfo" @close-user-info="closeUserInfo" @mtm-chat-join="mtmChatJoin"/>
  </pop-slide-up>
 
  <pop-mtm-chat :show="(mtm_chat || mtm_join !=='')&&user.id !==0" @close="close_mtm_chat" :chat_roomId="getMtmRoomId"/>
</template>

<script>
import { chatbody} from '@/components/mixins/chat/chatbody'
import ChatMessage from '@/mobile/components/chat/parts/ChatMessage'
import { auth } from '@/components/mixins/auth'
import { chatmtm } from '@/components/mixins/chat/chatmtm.js';
export default {
    mixins:[chatbody,auth,chatmtm],
    name: "mobile_chatMain",
    props:[     
    ],
    components:{
        ChatMessage
    },
    data() {
        return { 
          userInfo:{show:false},
          mtm_chat:false 
        };
    },  
    computed: {    
      getMtmState(){
        return this.mtm_chat
      },
      isOwner()
      {
          if(this.chatroomInfo){
              return this.user.id === this.chatroomInfo.user_id;
          }else{
              return false;
          }        
      },
      isManager(){
          if(this.chatroomInfo && this.chatroomInfo.manager.find((manager)=>manager.user_id === this.user.id))
          {
              return true;
          }else{
              return false;
          }
      }  
    },
    mounted() {   
      if(this.user.id === 0)
      {
        this.goLobby()  
      }
    },
    methods: {    
     
      goLobby(){
        this.$router.push({name:'m_ChatLobby'});
      }
    },
    watch:{
      user(data)
      {
        if(data.id === 0)
        {
          this.goLobby()  
        }
      }
    }
};
</script>

<style lang="scss" scoped>
.chat-window {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: Dotum;

  height: 100%;
  .messages-container {
    flex: 1 1 auto;
    flex-basis: 0px;
    overflow-y:auto;
    background:#dee3eb;
    .messages-list {
      font-size: 13px;
      letter-spacing: -1px;
        .adminMessage{
          background:#2943a3;
          color:#fff;
          margin: 3px 20px;
          line-height: 130%;
          text-overflow: ellipsis;
          word-break: break-all;
          padding: 3px 5px;
        }
        .message {
            padding: 5px 20px 5px 0;
            line-height: 130%;
            text-overflow: ellipsis;
            word-break: break-all;
            &:last-of-type {
            border-bottom: none;
            }
        }
        .red{
            background:#c30;
        }



    }
  }
  .input-container {
    width: 100%;
    border-top: 1px solid #dee3eb;
    border-bottom: 1px solid #dee3eb;
    flex-basis: 50px;
    .wrap-input {
      display: flex;
      .input-area {
        flex: 1;
        input {
          width: 100%;
          height: 50px;
          line-height: 50px;
          padding-left: 20px;
          font-size: 12px;
          font-family: Gulim, sans-serif;
          padding-right: 15%;
          border: none;
        }
      }
      .button-area {
        padding-top: 10px;
        width: 85px;
        padding-left: 5px;
        button {
          width: 75px;
          height: 35px;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
